import { LyneFormField } from "components/Lyne/LyneFormField";
import { LyneInput } from "components/Lyne/LyneInput";
import { sanitizeTrim } from "helpers";
import { CreateRunTopicModel } from "models/CreateRunTopicModel";
import { ResourceKeys, useEdecidePanel, useTranslations } from "providers";
import React from "react";

import { EdecideParticipantRow } from "./EdecideParticipantRow";
import { EdecideTopicRow } from "./EdecideTopicRow";

export const EdecidePanelPreview: React.FC = () => {
  const i18n = useTranslations();
  const { runTitle, runPreview, setRunTitle } = useEdecidePanel();

  if (!runPreview) {
    // should not happen, guarded by context isPreview.
    return null;
  }

  const sanitizedRunTitle = sanitizeTrim(runTitle);
  const topics = runPreview?.topics || [];
  const participants = runPreview?.participants || [];
  const existingRuns = runPreview?.existingRuns || [];

  return (
    <div className="container-fluid">
      <h5 className="panel-subtitle">{i18n.Run}</h5>

      <div className="form-group">
        <LyneFormField name="uniqueId" label={ResourceKeys.EdecidePanel_UniqueId} contextHelp={undefined}>
          {runPreview?.uniqueId}
        </LyneFormField>
      </div>

      {existingRuns.length > 0 && (
        <div className="mt-4 mb-2">
          <p className="text-danger mb-1">
            <b>{i18n.EdecidePanel_DuplicateRuns}:</b>
          </p>
          <p>{i18n.EdecidePanel_DuplicateRuns_Text}</p>

          <ul>
            {existingRuns.map((run, i) => (
              <li key={`duplicate-run-${i}`}>
                <a href={run.detailUrl} target="_blank" rel="noopener noreferrer" className="sbb-link">
                  {run.title} ({run.statusName})
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {existingRuns.length === 0 && (
        <>
          <div className="form-group">
            <LyneInput
              name="runTitle"
              label={ResourceKeys.EdecidePanel_OverrideTitle}
              contextHelp={ResourceKeys.EdecidePanel_OverrideTitle_HelpContent}
              value={sanitizedRunTitle}
              onChange={(text) => setRunTitle(text)}
            />
          </div>
          <hr />

          <div className="mt-4">
            <h5 className="panel-subtitle">{i18n.EdecidePanel_Topics}</h5>
            <table className="table sbb-table-bs table-sm">
              <thead>
                <tr>
                  w<th>{i18n.AgendaItem_HeadingNumber_Title}</th>
                  <th>{i18n.EdecidePanel_Topic_Type}</th>
                  <th>{i18n.EdecidePanel_Topic_Title}</th>
                </tr>
              </thead>
              <tbody>
                {topics.map((topic: CreateRunTopicModel, i: number) => (
                  <EdecideTopicRow key={`topic-${i}`} topic={topic} index={i} />
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4">
            <h5 className="panel-subtitle">{i18n.EdecidePanel_Participants}</h5>
            <table className="table sbb-table-bs table-sm">
              <thead>
                <tr>
                  <th>{i18n.EdecidePanel_Participant_Name}</th>
                </tr>
              </thead>
              <tbody>
                {participants.map((participant: string, i: number) => (
                  <EdecideParticipantRow key={`participant-${i}`} participant={participant} index={i} />
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};
